import column from './StatusColumn.vue'
const StatusColumn = {
  install: function (Vue) {
    Vue.component('StatusColumn', column)
  }
}
export default StatusColumn
